define([
    'angular',
    'jquery',
    'jquery-migrate', // Needed for Foundation 5.5.3
    'foundation-sites',
    'foundation-reveal',
    'foundation-tooltip',
    'foundation-alert',
], function (angular, $) {
    return angular
        .module('foundationDirectives', [])
        .directive('revealId', function () {
            // Make foundation reveal work for dynamically inserted elements

            // Bind custom close buttons
            $(document).on('click', '[data-reveal] .close', function () {
                $('#' + $(this).closest('[data-reveal]').attr('id')).foundation(
                    'reveal',
                    'close'
                );
            });
            return {
                restrict: 'A',
                template: function (element, attrs) {
                    var content = element.html();
                    // If target doesn't already exist, try to create it
                    var id = '#' + attrs.revealId;

                    if ($(id).length == 0) {
                        if (attrs.template) {
                            content +=
                                '<div id="' +
                                attrs.revealId +
                                '" class="reveal-modal small" data-reveal>' +
                                '<div ng-include="\'' +
                                attrs.template +
                                '\'"></div>' +
                                '</div>';
                        }
                    }
                    return content;
                },
                link: function (scope, element, attrs) {
                    var id = '#' + attrs.revealId;

                    $(element).on('click', function () {
                        $(id).foundation('reveal', 'open');
                    });
                },
            };
        })
        .directive('tooltip', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(document).foundation('tooltip', 'reflow');
                },
            };
        })
        .directive('alert', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(document).foundation('alert', 'reflow');
                },
            };
        });
});
